import { cn } from '@/utils/cn'

interface BrandLogoProps {
  collapsed?: boolean
  className?: string
}

function resolveBrandLogoAsset(fileName: string) {
  return new URL(`../../../public/branding/${fileName}`, import.meta.url).href
}

export default function BrandLogo({ collapsed = false, className }: BrandLogoProps) {
  const lightSrc = collapsed
    ? resolveBrandLogoAsset('AgentMauriceLogoLightCollapsed.svg')
    : resolveBrandLogoAsset('AgentMauriceLogoLightExpanded.svg')
  const darkSrc = collapsed
    ? resolveBrandLogoAsset('AgentMauriceLogoDarkCollapsed.svg')
    : resolveBrandLogoAsset('AgentMauriceLogoDarkExpanded.svg')

  return (
    <span className={cn('inline-flex items-center', className)}>
      <img
        src={lightSrc}
        alt="AgentMaurice"
        className={cn('block w-auto dark:hidden', collapsed ? 'h-8' : 'h-10')}
      />
      <img
        src={darkSrc}
        alt="AgentMaurice"
        className={cn('hidden w-auto dark:block', collapsed ? 'h-8' : 'h-10')}
      />
      <span className="sr-only">AgentMaurice</span>
    </span>
  )
}
